<h1 mat-dialog-title>Supression définitive</h1>

<div mat-dialog-content>
  <p>
    Le fichier <b (click)="copy()" matTooltip="Copier">{{ file.name }}</b> va être définitivement supprimer. Voulez vous continuer ?
  </p>

  <mat-form-field appearance="fill">
    <mat-label>Enter le non du fichier</mat-label>
    <input matInput [(ngModel)]="value" placeholder="nom du fichier" />
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button mat-raised-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="warn" (click)="validate()" [disabled]="value !== file.name">Supprimer</button>
</div>
